export const environment = {
  production: false,
  apiUrl: 'https://dev.unifiedstaff.com/'
};